import React from "react";
import ReactDOM from "react-dom";
import SearchCoursesViewContainer from "./SearchCoursesViewContainer";

const rootElement = document.getElementById("courses-search-results");
ReactDOM.createRoot(rootElement).render(<SearchCoursesViewContainer />);
